/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import 'src/styles/reset.scss'
import 'flexboxgrid/css/flexboxgrid.min.css'
import 'src/styles/main.scss'


const Layout = ({ children }) => {
  return (<>
      <main>{children}</main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
